/**
 * Save the size used at checkout to the customer profile (logged-in shop customers), so future
 * product pages can pre-select it. Mirrors persistCustomerShippingAfterOrder in
 * customerShippingAddress.js — non-blocking for checkout, callers should catch errors.
 */
import { API_ENDPOINTS } from '../config/api';

export async function persistCustomerSizeAfterOrder({ getAuthHeaders, refreshCustomer, size }) {
  if (!size) return;

  const res = await fetch(API_ENDPOINTS.customerProfile.me, {
    method: 'PUT',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferredSize: size }),
  });

  if (!res.ok) {
    throw new Error(`Profile size save failed (${res.status})`);
  }

  if (typeof refreshCustomer === 'function') {
    await refreshCustomer();
  }
}
